/**
 * Shared constants for the V2 dashboard
 */

/** Standard entity status values used by orgs, channels, devices, and alerts */
export const ENTITY_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0
} as const;

/** Default alert rate limits — server-configurable via getAlertLimits. */
export const DEFAULT_RATE_LIMITS = {
  day: 20,
  week: 100
} as const;
